import * as React from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch, { SwitchProps } from '@mui/material/Switch';
type Props = Omit<SwitchProps, 'variant' | 'error'> & {
  label: string;
};



export default function SwitchLabels(props: Props) {
  return (
    <FormGroup>
      <FormControlLabel
        style={{ pointerEvents: 'none' }}
        control={<Switch style={{ pointerEvents: 'auto' }} {...props} />}
        label={props.label}
      />
    </FormGroup>
  );
}
